import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { shallowEqual, useSelector } from 'react-redux'

import ConfigContext from '../../contexts/configContext'

import { translate } from '../../helpers/stringHelpers'

// components
import Badge from '../badge'
import { formatCurrency } from '../../helpers/currencyHelpers'
import List from '../list'
import ListItem from '../listItem'
import Row from '../row'
import Col from '../col'

const OffersList = ({
  listingUuid
}) => {
  const { locale } = useContext(ConfigContext)
  const currencyCode = useSelector(state => state.listingSales.sales[listingUuid]?.currencyCode)
  const highestOfferUuid = useSelector(state => state.saleStatuses.saleStatuses[listingUuid]?.highestOfferUuid)
  const offers = useSelector(state => state.offers.offersByListing[listingUuid]
    ?.map(offerUuid => state.offers.offers[offerUuid]), shallowEqual)
  if (!currencyCode || !offers || !offers.length) return null

  const currencyFormat = formatCurrency.bind(null, locale, currencyCode)

  return ([
    <h6 key='offer-list__heading'>{translate('JspPublicCodes_JSP_LISTING_OFFER_PREVIOUS_OFFERS')}</h6>,
    <List key='offer-list__items'>
      {offers.map(offer => {
        const isRejected = offer.rejected || (highestOfferUuid && highestOfferUuid !== offer.uuid)
        const isAccepted = highestOfferUuid === offer.uuid
        return (
          <ListItem key={`offer${offer.uuid}`} id={`offer-list__item--${offer.uuid}`}>
            <Row>
              <Col
                xs={8} md={9} lg={10}
                className='offer__value'
                id={`offer__value--${offer.uuid}`}
              >
                {currencyFormat(offer.amount)}
              </Col>
              <Col xs={4} md={3} lg={2} className='text-right'>
                <Badge
                  className='offer__status'
                  id={`offer__status--${offer.uuid}`}
                  color={
                    isRejected
                      ? 'danger'
                      : isAccepted
                        ? 'success'
                        : 'warning'
                  }
                >
                  {translate(
                    isRejected
                      ? 'MyBidsSearchTypeEnum_REJECTED'
                      : isAccepted
                        ? 'MyBidsSearchTypeEnum_WON'
                        : 'MyBidsSearchTypeEnum_PENDING'
                  )}
                </Badge>
              </Col>
            </Row>
          </ListItem>
        )
      })}
    </List>
  ])
}

OffersList.propTypes = {
  listingUuid: PropTypes.string.isRequired
}

export default React.memo(OffersList)
